export default __webpack_public_path__ + "static/media/martiyers10.322b4b66.jpg";